<!-- eslint-disable no-undef -->
<template>
  <div class="lucky">
    <div class="img-title">
      <img src="@/assets/prize/title.png" alt="" />
    </div>

    <LuckyWheel
      ref="myLucky"
      class="my-lucky"
      width="280px"
      height="360px"
      :prizes="prizes"
      :blocks="blocks"
      :buttons="buttons"
      @start="startCallFn"
      @end="endCallback"
    />
    <div class="btn-time" @click="startCallback()">
      <img src="@/assets/prize/submit.png" alt="" />
    </div>
    <model
      ref="model"
      :win-price="winPrice"
      :is-check-win-answer="isCheckWinAnswer"
    ></model>
  </div>
</template>

<script>
// import LuckyWheel from "@lucky-canvas/vue";
import model from "./components/model";
import { Toast } from "vant";
import { fxFn, toLoginFn, metaFn } from "./fx";
export default {
  components: { model },
  data() {
    return {
      winPrice: "",
      isCheckWinAnswer: "",
      blocks: [
        {
          padding: "30px",
          background: "#fff",
          imgs: [
            {
              src: require("@/assets/prize/dz.png"),
              width: "100%",
              top: "90%",
              // height: "100%",
            },
            {
              src: require("@/assets/prize/cavans-bg.png"),
              width: "100%",
              height: "100%",
            },
          ],
        },
      ],
      prizes: [
        {
          fonts: [{ text: 0, top: "10%", fontColor: "rgba(255, 255, 255,0)" }],
          imgs: [
            {
              src: require("@/assets/prize/itemNum/0.png"),
              top: "0",
              width: "100%",
            },
          ],
          background: "#FEF3FC",
        },
        {
          fonts: [
            { text: 0.5, top: "10%", fontColor: "rgba(255, 255, 255,0)" },
          ],
          imgs: [
            {
              src: require("@/assets/prize/itemNum/0.5.png"),
              top: "0",
              width: "100%",
            },
          ],
          background: "#FEF3FC",
        },
        {
          fonts: [{ text: 1, top: "10%", fontColor: "rgba(255, 255, 255,0)" }],
          imgs: [
            {
              src: require("@/assets/prize/itemNum/1.png"),
              top: "0",
              width: "100%",
            },
          ],
          background: "#FEF3FC",
        },
        {
          fonts: [{ text: 2, top: "10%", fontColor: "rgba(255, 255, 255,0)" }],
          imgs: [
            {
              src: require("@/assets/prize/itemNum/2.png"),
              top: "0",
              width: "100%",
            },
          ],
          background: "#FEF3FC",
        },
        {
          fonts: [{ text: 3, top: "10%", fontColor: "rgba(255, 255, 255,0)" }],
          imgs: [
            {
              src: require("@/assets/prize/itemNum/3.png"),
              top: "0",
              width: "100%",
            },
          ],
          background: "#FEF3FC",
        },
        {
          fonts: [{ text: 5, top: "10%", fontColor: "rgba(255, 255, 255,0)" }],
          imgs: [
            {
              src: require("@/assets/prize/itemNum/5.png"),
              top: "0",
              width: "100%",
            },
          ],
          background: "#FEF3FC",
        },
      ],
      buttons: [
        {
          radius: "30%",
          pointer: true,
          imgs: [
            {
              top: "-140%",
              src: require("@/assets/prize/zz.png"),
              width: "100%",
              // height: "100%",
            },
          ],
        },
      ],
    };
  },
  created() {
    if (toLoginFn()) {
      return;
    }
    this.getList();
    metaFn();
  },
  methods: {
    async getList() {
      let array = [0, 0.5, 1, 2, 3, 5];
      let winPrice = localStorage.getItem("winPrice");
      this.winPrice = winPrice || 0;
      if (winPrice) {
        let index = array.indexOf(Number(winPrice));
        this.indexBonus = index;
      } else {
        this.indexBonus = 0;
      }
      this.isCheckWinAnswer = localStorage.getItem("isCheckWinAnswer");
      // if (this.isCheckWinAnswer) {
      //   this.$nextTick(() => {
      //     this.$refs.model.init();
      //   });
      // }
      // 2. 初始化配置

      // console.log(window.wx);
      // eslint-disable-next-line no-undef
      fxFn(wx);
    },
    startCallFn() {},
    wxFn() {},
    // 点击抽奖按钮会触发star回调
    startCallback() {
      // alert("点了下");
      // this.wxFn();
      if (this.isCheckWinAnswer == 1) {
        Toast({ type: "warning", message: "您已经抽过奖了!" });
        return;
      }
      // 调用抽奖组件的play方法开始游戏
      this.$refs.myLucky.play();
      // 模拟调用接口异步抽奖
      setTimeout(() => {
        // 假设后端返回的中奖索引是0
        const index = this.indexBonus;
        // 调用stop停止旋转并传递中奖索引
        this.$refs.myLucky.stop(index);
      }, 3000);
    },
    // 抽奖结束会触发end回调
    endCallback() {
      this.isCheckWinAnswer = true;
      setTimeout(() => {
        this.$refs.model.init();
      }, 1000);
    },
  },
};
</script>
<style lang="scss" scoped>
.lucky {
  width: 100vw;
  height: 100vh;
  background: url("~@/assets/prize/bg.png") no-repeat;
  background-size: 100% 100%;
  background-color: #7f5ce5;
  background-attachment: fixed;
  padding-top: 40px;
  .btn-time {
    width: 100%;
    padding: 0 48px;
  }
  .my-lucky {
    margin: 0px auto;
  }
  .img-title {
    width: 100%;
    text-align: center;
    img {
      display: block;
      margin: 0 auto;
      width: 60%;
    }
  }
}
</style>
